import { useTranslation } from "react-i18next";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { checkMoney, convertIdentifiers, listMoneyObj } from "../../utils/configData";
import sepaLogo from "../../assets/images/SEPA-logo-add-wallet.png";
import swiftLogo from "../../assets/images/SWIFT-logo-add-wallet.png";

const NewInputExchange = React.forwardRef(
    (
        {
            pair,
            lastUpdate,
            walletsInfo,
            setKeyWallet,
            selectedBuy,
            change,
            type,
            value,
            selected,
            setSelected,
            currencies,
            setMethod,
            keyWallet,
            style,
            onChange
        },
        ref
    ) => {
        const { t } = useTranslation();

        const userInfo = useSelector((state) => state.user);
        // const [convertChoseCurr, setConvertChoseCurr] = useState(convertCurrs[0]);
        const [chosenWallet, setChosenWallet] = useState(t("Select wallet"));
        const [logoMethod, setLogoMethod] = useState(null);
        const defaultRef = useRef(null);
        const buttonDropdown = useRef(null);
        const [methodText, setMethodText] = useState(
            change
                ? t("The payment method depends on the bank you choose")
                : t("The payment method depends on the wallet you choose")
        );

        const choseCurr = (index) => () => {
            setSelected(currencies[index]);

            dropdown.current.classList.remove("show");
            iconDropdown.current.classList.remove("show");
        };

        const isFocused = useRef(null);
        const handleChange = (e) => {
            const inputValue = e.target.value;
            const isNumeric = /^-?\d*\.?\d*$/.test(inputValue);
            if (isFocused.current && document.activeElement === isFocused.current) {
                if (isNumeric || inputValue === "") {
                    onChange(e.target.value, type === "bank");
                }
            }
        };

        const choseWallet = (index) => () => {
            if (type === "bank") {
                // setChosenWallet(walletsInfo[index].owner);
                setChosenWallet(userInfo.fname + " " + userInfo.lname);

            } else {
                setChosenWallet(walletsInfo[index].name);
            }
            setSelected(listMoneyObj.find(item => item.type === walletsInfo[index].curr));

            setMethodText(
                walletsInfo[index].curr.toUpperCase() +
                " " +
                walletsInfo[index].type.toUpperCase()
            );

            setKeyWallet([index, walletsInfo[index].key]);
            if (walletsInfo[index].type === "sepa" || walletsInfo[index].type === "swift") {
                setMethod(walletsInfo[index].type)
            }

            if (walletsInfo[index].type === "sepa") {
                setLogoMethod(sepaLogo);
            } else if (walletsInfo[index].type === "swift") {
                setLogoMethod(swiftLogo);
            } else {
                setLogoMethod(checkMoney(walletsInfo[index].curr).img);
            }



            dropdownWallet.current.classList.remove("show");
            iconDropdownWallet.current.classList.remove("show");
            defaultRef.current.classList.remove("default");
        };
        const dropdown = useRef(null);
        const iconDropdown = useRef(null);

        const showDropdown = () => {
            dropdown.current.classList.toggle("show");
            iconDropdown.current.classList.toggle("show");
        };

        const showDropdownWallet = () => {

            dropdownWallet.current.classList.toggle("show");
            iconDropdownWallet.current.classList.toggle("show");

        };
        const dropdownWallet = useRef(null);
        const iconDropdownWallet = useRef(null);
        const formatReceiver = (receiver) => {
            if (window.innerWidth >= 768) {
                return receiver.length <= 10 ? receiver : receiver.slice(0, 10) + "...";
            } else {
                return receiver;
            }

        };

        useEffect(() => {
            function handleOutsideClick(event) {
                if (
                    dropdownWallet.current &&
                    !dropdownWallet.current.contains(event.target) &&
                    !defaultRef.current.contains(event.target)
                ) {
                    dropdownWallet.current.classList.remove("show");
                    iconDropdownWallet.current.classList.remove("show");
                }
                if (
                    dropdown.current &&
                    !dropdown.current.contains(event.target) &&
                    !buttonDropdown.current.contains(event.target)
                ) {

                    dropdown.current.classList.remove("show");
                    iconDropdown.current.classList.remove("show");
                    // Тут виконуємо вашу функцію
                }
            }

            document.addEventListener("mousedown", handleOutsideClick);

            return () => {
                document.removeEventListener("mousedown", handleOutsideClick);
            };
        }, []);


        /**
         * Converts occurrences of 'trc' followed by numbers in the input string
         * to a formatted string '(TRC-XXX)', where 'XXX' are the captured numbers.
            
         */


        return (
            <div className="form-default flex-column" ref={ref} style={style}>
                <h3 className="grid-column-span-2">
                    {change ? t("Give") : t("Receive")}
                </h3>
                <div className="container-give">
                    <div className="curr-input">
                        <label htmlFor="amountCurr">{t("Amount")}</label>
                        <div className="wrapper-input">
                            <input
                                id="amountCurr"
                                type="text"
                                value={value}
                                onChange={handleChange}
                                placeholder="0.00"
                                ref={isFocused}

                            />
                            <div className="select-button">
                                <p ref={buttonDropdown} onClick={showDropdown}>
                                    <img src={selected?.img || ""} alt="" />
                                    {selected?.type ? selected.type.toUpperCase() : ""}
                                    <i ref={iconDropdown} className="ri-arrow-down-s-line"></i>
                                </p>
                                <div ref={dropdown} className="select-button__option">
                                    {currencies.map((curr, index) => (
                                        <p
                                            className={
                                                curr.type !== selected.type && !keyWallet ? "" : "disabled"
                                            }
                                            key={index}
                                            title={
                                                curr.type !== selected.type && !keyWallet
                                                    ? ""
                                                    : t(
                                                        "You cannot use this currency with the wallet you have chosen"
                                                    )
                                            }
                                            onClick={
                                                curr.type !== selected.type && !keyWallet
                                                    ? choseCurr(index)
                                                    : null
                                            }
                                        >
                                            <img src={curr?.img || ""} alt="" />
                                            {curr?.type?.toUpperCase()}
                                        </p>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div
                            style={change ? { display: "flex" } : { display: "none" }}
                            className="info-comision"
                        >
                            <p>
                                <span>1</span> {selected?.type?.toUpperCase() || ""} = <span>{pair}</span> {selectedBuy?.type?.toUpperCase() || ""}
                            </p>
                            <p>
                                {t("Last updated")}: <span>{lastUpdate}</span>
                            </p>
                        </div>
                    </div>
                    <div className="wallet-input">
                        <label>{change ? t("Pay with") : t("Receive on")}</label>
                        <div className="wrapper-input">
                            <div className="select-button">
                                <p
                                    onClick={showDropdownWallet}
                                    ref={defaultRef}
                                    className="default"
                                >
                                    <i
                                        style={{ color: "#1F363C4D", marginLeft: "0px" }}
                                        className="ri-wallet-line"
                                    ></i>
                                    {"   "}
                                    {formatReceiver(chosenWallet)}
                                    <i
                                        ref={iconDropdownWallet}
                                        className="ri-arrow-down-s-line"
                                    ></i>
                                </p>
                                <div ref={dropdownWallet} className="select-button__option">
                                    {type === "bank"
                                        ? walletsInfo.map((wallet, index) =>
                                            wallet.visib === 1 ? (
                                                <div
                                                    key={index}
                                                    onClick={choseWallet(index)}
                                                    className="wallet__item-ex"
                                                >
                                                    <div className="grid-row-span-2 number-wallet">
                                                        {wallet.type === "sepa" ? (
                                                            <img src={sepaLogo} alt="logo SEPA" />
                                                        ) : (
                                                            <img src={swiftLogo} alt="logo SWIFT" />
                                                        )}
                                                    </div>
                                                    <h4>{userInfo.fname + " " + userInfo.lname}</h4>
                                                    <h5 className="grid-column-2 grid-row-2">
                                                        {wallet.curr.toUpperCase()}{" "}
                                                        {t("account ending in")} {wallet.iban.slice(-4)}
                                                    </h5>
                                                </div>
                                            ) : null
                                        )
                                        : walletsInfo.map((wallet, index) =>
                                            wallet.visib === 1 ? (
                                                <div
                                                    key={index}
                                                    onClick={choseWallet(index)}
                                                    className="wallet__item-ex"
                                                >
                                                    <div className="grid-row-span-2 number-wallet">
                                                        #{index + 1}
                                                    </div>
                                                    <h4>{wallet.name}</h4>
                                                    <h5 className="grid-column-2 grid-row-2">
                                                        {wallet.curr.toUpperCase()} {`${convertIdentifiers(wallet.type.toUpperCase())}`}{" "}
                                                        {t("crypto wallet ending in")}{" "}
                                                        {wallet.num.slice(-4)}
                                                    </h5>
                                                </div>
                                            ) : null
                                        )}
                                    <Link to={`/settings`}>
                                        <p>
                                            <i
                                                style={{ marginLeft: 0 }}
                                                className="ri-add-circle-line f-s-20"
                                            ></i>{" "}
                                            {type === "bank" ? t("Add bank account") : t("Add new wallet")}
                                        </p>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="payment-method-curr">
                    <label>{t("Payment method")}</label>
                    <p>
                        <img
                            className={
                                logoMethod ? (type === "bank" ? "bank" : "crypto") : null
                            }
                            src={logoMethod}
                            alt=""
                        />
                        {logoMethod ? (type === "crypto" ? `${convertIdentifiers(methodText)}` : null) : methodText}
                    </p>
                </div>
            </div>
        );
    }
);

export default NewInputExchange;
